import SignInPageTitle from "./ui/SignInPageTitle";
import SignInPageSlideSection from "./ui/SignInPageSlide.section";
import { LOGIN_UNIFICADO } from "@/configs/runtime";
import clsx from "clsx";
import { useMediaQuery } from "@mui/material";
import FormularioEntrarJwt from "@auth/services/jwt/components/LoginForm/FormularioEntrarJwt";

// ------------------------------- CONSTANTS -------------------------------
const STAR_FIELD_BACKGROUND =
	"radial-gradient(2px 2px at 20% 20%, rgba(255,255,255,.55) 0%, transparent 100%), radial-gradient(2px 2px at 72% 8%, rgba(255,255,255,.4) 0%, transparent 100%), radial-gradient(1.4px 1.4px at 38% 65%, rgba(255,255,255,.5) 0%, transparent 100%), radial-gradient(1.4px 1.4px at 88% 44%, rgba(255,255,255,.45) 0%, transparent 100%), radial-gradient(2px 2px at 5% 80%, rgba(255,255,255,.3) 0%, transparent 100%), radial-gradient(1.4px 1.4px at 60% 90%, rgba(255,255,255,.4) 0%, transparent 100%), radial-gradient(1.4px 1.4px at 25% 45%, rgba(255,255,255,.35) 0%, transparent 100%), radial-gradient(1.4px 1.4px at 50% 30%, rgba(255,255,255,.5) 0%, transparent 100%), radial-gradient(1.4px 1.4px at 93% 70%, rgba(255,255,255,.3) 0%, transparent 100%), radial-gradient(1.4px 1.4px at 80% 15%, rgba(255,255,255,.6) 0%, transparent 100%)";

const NEBULA_BACKGROUND =
	"radial-gradient(ellipse 60% 40% at 10% 80%, rgba(80,74,153,.18) 0%, transparent 60%), radial-gradient(ellipse 50% 35% at 90% 20%, rgba(118,176,191,.14) 0%, transparent 55%), radial-gradient(ellipse 70% 50% at 50% 50%, rgba(3,55,112,.12) 0%, transparent 70%)";

// ------------------------------- COMPONENT -------------------------------
function SignInPageView() {
	// -------------------------------- STATES --------------------------------
	const telaDesktop = useMediaQuery("(min-width: 960px)");
	const compacto = LOGIN_UNIFICADO && telaDesktop;

	// -------------------------------- RETURN --------------------------------
	return (
		<main
			className={clsx(
				"relative flex min-h-dvh w-full items-center justify-center overflow-x-hidden bg-[#040d1a] font-sans sm:px-6 md:px-8",
				LOGIN_UNIFICADO ? "px-2" : "px-4",
				compacto ? "py-4" : "py-6",
			)}
		>
			<div
				className="pointer-events-none fixed inset-0 z-0 opacity-80"
				style={{
					backgroundImage: STAR_FIELD_BACKGROUND,
					backgroundSize: "600px 600px",
				}}
			/>
			<div
				className="pointer-events-none fixed inset-0 z-0 opacity-50"
				style={{
					backgroundImage: STAR_FIELD_BACKGROUND,
					backgroundSize: "900px 900px",
					transform: "translate(24px, 18px)",
				}}
			/>
			<div
				className="pointer-events-none fixed inset-0 z-0"
				style={{
					background: NEBULA_BACKGROUND,
				}}
			/>

			<section
				data-densidade={compacto ? "compacta" : "normal"}
				className={clsx(
					"group/login relative z-10 flex w-full max-w-105 overflow-hidden rounded-[20px] shadow-[0_0_0_1px_rgba(255,255,255,.06),0_32px_80px_rgba(0,0,0,.7),0_0_60px_rgba(80,74,153,.18)]",
					LOGIN_UNIFICADO ? "md:min-h-140 md:max-w-250" : "md:h-140 md:max-w-240",
				)}
			>
				<div
					className={clsx(
						"relative flex w-full shrink-0 flex-col overflow-hidden bg-white/97 backdrop-blur-2xl",
						compacto ? "px-8 py-6" : "py-8 sm:px-10 sm:py-10",
						LOGIN_UNIFICADO && !compacto ? "px-[clamp(2px,calc((100vw-316px)/2),24px)]" : undefined,
						LOGIN_UNIFICADO ? undefined : "px-6",
						LOGIN_UNIFICADO && !compacto ? "min-h-165" : "min-h-140",
						"md:w-95",
					)}
				>
					<div className="absolute inset-x-0 top-0 h-0.75 bg-[linear-gradient(90deg,#e6215a,#504a99,#76b0bf)]" />

					<SignInPageTitle />

					<div className={compacto ? "mb-6" : "mb-8"}>
						<p className="mb-1 text-[13px] font-normal tracking-[0.06em] text-[#8899aa] uppercase">
							Bem-vindo de volta
						</p>
						<h1 className="text-[22px] leading-[1.2] font-bold text-[#0d1b2e]">
							Acesse sua conta <span className="text-[#e6215a]">Space</span>
						</h1>
					</div>

					<FormularioEntrarJwt densidade={compacto ? "compacta" : "normal"} />
				</div>

				<SignInPageSlideSection />
			</section>
		</main>
	);
}

export default SignInPageView;
